import { FormSpy } from "react-final-form";
import { TitlePageNew, VideoPreview } from "~/components";
import {
  composeValidators,
  required,
  testRegExp
} from "~/utils/validate";
import { Divider } from "antd";
import {
  FormField,
  FormFieldBic
} from "~/pages/questionnaires/shared";
import { NamesOfFieldEnum } from "~/typings/types";
import { configTitleFieldsOfSelfEmployed, configTitleFieldsOfBank } from "../configTitleFields";
import { GET_BANK_INFO } from "~/pages/questionnaires/v1/customer/api/apiUrls";
import { V2Wizard } from "../../../../shared/wizard";
import { FullWidthRowFormContainer } from "~/pages/questionnaires/shared/form-field";

import styles from "./CommonSteps.module.scss";
import { useScrollAndFocusField } from "~/hooks";
import { useAnalyticsContext } from "~/services/analytics";
import { useState } from "react";

interface CompanyDetailsProps {
  clientId: string;
}

export const CompanyDetails = ({ clientId }: CompanyDetailsProps) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isBankConfirmed, setIsBankConfirmed] = useState(false);

  useScrollAndFocusField(NamesOfFieldEnum.BankBic);

  const analytics = useAnalyticsContext();
  analytics?.trackStep('anketa-customer-se-init_step3');
  analytics?.trackStepWebvisor('webvisor_anketa_customer_step2');

  return (
    <V2Wizard.Page>
      <TitlePageNew
        name="Укажите реквизиты для вывода средств"
        number="3"
        // description="Если у вас нет реквизитов под рукой, вы сможете заполнить их позже в личном кабинете. Чтобы перейти к следующему шагу анкеты, нажмите «Продолжить»"
        descriptionNode={<button type="button" className={styles.buttonTutorial} onClick={() => setIsVideoOpen(true)}>Посмотреть видео-инструкцию, где найти реквизиты в приложении банка</button>}
      />
      <Divider style={{ margin: 0 }} />
      <div className={styles.container}>

        <VideoPreview
          videoSrc="/videos/bank-details-tutorial.mp4"
          previewImage="/images/bank-video-preview.jpg"
          title="Где найти реквизиты в приложении банка"
          isOpen={isVideoOpen}
          onOpenChange={setIsVideoOpen}
        />

        <FullWidthRowFormContainer>
          <FormSpy>
            {propsSpy => {
              return (
                <FormFieldBic
                  titleField={configTitleFieldsOfSelfEmployed[NamesOfFieldEnum.BankBic]}
                  name={NamesOfFieldEnum.BankBic}
                  required
                  validate={composeValidators(
                    required(),
                    testRegExp(/^04(\d){7}$/g, 'БИК должен начинаться на "04" и состоять из 9 цифр')
                  )}
                  configNameFieldsModalSuggestion={configTitleFieldsOfBank}
                  propsSpy={propsSpy}
                  clientId={clientId}
                  tooltip="БИК — уникальный код банка. Он состоит из девяти цифр"
                  descriptionField="Введите БИК или название банка - остальные данные заполним автоматически"
                  urlGetBankInfo={GET_BANK_INFO}
                  onBankConfirmed={setIsBankConfirmed}
                />
              );
            }}
          </FormSpy>
        </FullWidthRowFormContainer>

        {
          // Костыль для валидации поля БИК, разобраться почему не выводится ошибка валидации БИК без этого скрытого поля
        }
        <div style={{ position: 'absolute', top: 0, left: 0, width: 0, height: 0, overflow: 'hidden' }}>
          <FormField
            titleField={configTitleFieldsOfSelfEmployed[NamesOfFieldEnum.BankBic]}
            name={NamesOfFieldEnum.BankBic}
            required
            validate={composeValidators(
              required(),
              testRegExp(/^04(\d){7}$/g, 'БИК должен начинаться на "04" и состоять из 9 цифр')
            )}
          />
        </div>

        {!isBankConfirmed && (
          <FullWidthRowFormContainer>
            <FormField
              titleField={configTitleFieldsOfSelfEmployed[NamesOfFieldEnum.BankName]}
              name={NamesOfFieldEnum.BankName}
              required
              validate={composeValidators(required())}
            />
          </FullWidthRowFormContainer>
        )}

        {isBankConfirmed && (
          <FullWidthRowFormContainer>
            <FormField
              titleField={configTitleFieldsOfSelfEmployed[NamesOfFieldEnum.SettlementAccount]}
              name={NamesOfFieldEnum.SettlementAccount}
              maxLength={20}
              required
              validate={composeValidators(
                required(),
                (value: string) => {
                  const v = String(value || "");
                  if (!/^\d{20}$/.test(v)) return "Некорректный номер счёта";
                  if (v.startsWith("408178") || v.startsWith("4082")) return undefined;
                  return "Некорректный номер счёта";
                }
              )}
            />
          </FullWidthRowFormContainer>
        )}

        {!isBankConfirmed && (
          <FormField
            titleField={configTitleFieldsOfSelfEmployed[NamesOfFieldEnum.SettlementAccount]}
            name={NamesOfFieldEnum.SettlementAccount}
            maxLength={20}
            required
            validate={composeValidators(
              required(),
              (value: string) => {
                const v = String(value || "");
                if (!/^\d{20}$/.test(v)) return "Некорректный номер счёта";
                if (v.startsWith("408178") || v.startsWith("4082")) return undefined;
                return "Некорректный номер счёта";
              }
            )}
          />
        )}

        {!isBankConfirmed && (
          <FormField
            titleField={configTitleFieldsOfSelfEmployed[NamesOfFieldEnum.CorrespondentAccount]}
            name={NamesOfFieldEnum.CorrespondentAccount}
            maxLength={20}
            required
            validate={composeValidators(
              required(),
              testRegExp(
                /^301(\d){17}$/g,
                'Номер корреспондентского счёта должен начинаться на "301" и состоять из 20 цифр'
              )
            )}
          />
        )}

      </div>
    </V2Wizard.Page>
  );
};
